module.exports = __webpack_public_path__ + "img/a-02.9b20a5ce.png";